import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import * as Styled from './MenuItem.style';

function UserMenuItem({
  divider,
  icon: Icon,
  onClick,
  title,
  to
}) {
  return (
    <Styled.Root divider={divider}>
      <Styled.Link
        clickstreamProps={{
          elementName: 'user_menu_option',
          elementText: title
        }}
        onClick={onClick}
        to={to}
      >
        <Icon color="text.secondary" />
        <Text component="span" truncate>{title}</Text>
      </Styled.Link>
    </Styled.Root>
  );
}

UserMenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  divider: PropTypes.oneOf(['top', 'bottom']),
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired
};

export default UserMenuItem;
